<template>
  <v-dialog
    v-model="showModal"
    persistent
    :max-width="getWidth"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h3 style="word-break: break-word">{{ showTitle }}</h3>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-row>
          <v-col style="display: flex;" cols="12" class="py-0 pt-2">
            <el-text-field
              label="IS identifikatorius"
              v-model="is_identificator"
              :min="3"
              required
              :maxlength="20"
            >
            </el-text-field>
             <el-button
                style="height: 40px;"
                class="ml-1"
                title="Ieškoti"
                :loading="loading"
                color="primary"
                icon="ieškoti"
                @click.native.stop="getList()"
            />
          </v-col>
          <v-col class="pt-0" cols="12">
            <v-simple-table dense>
              <tbody>
                <tr v-for="subItem in list" :key="subItem.value">
                  <td style="cursor: pointer;" @click="addItem(subItem)">{{ subItem }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <template>
          <el-button
          class="mr-2"
            title="Atšaukti"
            :loading="loading"
            @click.native.stop="closeModal()"
            color="secondary"
          />
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { classifiersGet } from '@/services/classifierService.js'
export default {
  name: 'ModalSearchIsIdentificator',

  $_veeValidate: {
    validator: 'new',
  },
  components: {
  },
  data() {
    return {
      list: [],
      is_identificator: '',
      itemList: [],
      addItemList: [],
      paginationloading: false,
      loading: false,
      itemsPerPageOptions: [10, 50, 100],
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'left',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Paslauga'),
          align: 'start',
          value: 'text',
        },
      ]
    },
    getWidth() {
      return '500px'
    },
    showTitle() {
      return 'Paieška'
    },
    showModal() {
      return true
    },
  },
  created() {
  },
  methods: {
    getList(){
      this.$validator.validateAll().then((res) => {
        if (res) {
            this.loading = true
            this.$axios
              .get(`is-identificator`, { params: { fragment: this.is_identificator } })
              .then((res) => {
                this.list = res.data
              })
              .catch((err) => {
                this.$root.$emit('DATA_ERROR', err)
              })
              .finally(() => {
                this.loading = false
              })
        } else {
              this.$root.$emit('FORMAT_ERROR')
            }
      })
    },
    addItem(item) {
       this.$emit('close-modal', item)
    },
    closeModal() {
      this.$emit('close-modal')
    },
    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped></style>
